import { Provider } from '@angular/core';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';

export function provideLocale(): Provider[] {
  return [
    provideTranslocoLocale({
      langToLocaleMapping: {
        en: 'en-US',
        da: 'da-DK',
        ar: 'ar-EG',
        fr: 'fr-FR',
      },
    }),
  ];
}
